import { render, staticRenderFns } from "./FloatingAIButton.vue?vue&type=template&id=311a5190&scoped=true"
import script from "./FloatingAIButton.vue?vue&type=script&lang=js"
export * from "./FloatingAIButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingAIButton.vue?vue&type=style&index=0&id=311a5190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a5190",
  null
  
)

export default component.exports